

























import { Component, Prop, Vue } from 'vue-property-decorator';
import { CloseButton, LinkButton } from '@/components/Base';
import { KEYCLOAK_LOGOUT_URL } from '@/constants/urls';

@Component({
  components: {
    CloseButton,
    LinkButton,
  },
})
export default class MobileMenu extends Vue {
  @Prop() public items: string[];
  public KEYCLOAK_LOGOUT_URL = KEYCLOAK_LOGOUT_URL;

  public handleCloseClick() {
    this.$store.dispatch('toggleMobileMenu', false);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileMenu/MobileMenu.vue